module.exports = __webpack_public_path__ + "static/media/29EUNOG3.d3b87ada.jpg";